__turbopack_context__.v({
  "bioPic": "People-module-scss-module__0hMBhW__bioPic",
  "cardBox": "People-module-scss-module__0hMBhW__cardBox",
  "cardsWrap": "People-module-scss-module__0hMBhW__cardsWrap",
  "cta": "People-module-scss-module__0hMBhW__cta",
  "singlePerson": "People-module-scss-module__0hMBhW__singlePerson",
  "socialLink": "People-module-scss-module__0hMBhW__socialLink",
});
